var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BNavbarToggle',{class:{
        'mobile-toggle background-black' : _vm.$isWealthTime && !_vm.isWhitelabeled,
        'mobile-toggle' : _vm.$isWealthTime && _vm.isWhitelabeled
    },attrs:{"target":_vm.navbarCollapseId}},[_c('i',{staticClass:"material-icons"},[_vm._v("menu")])])}
var staticRenderFns = []

export { render, staticRenderFns }